import React from "react";
import {
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableHead,
	TableRow,
} from "@mui/material";
import { TableLoader, TableNotFound } from "src/Utils/TableLoader";
import type { IVisitorListItem } from "../type/newVisitorType";
import VisitorTableRow from "./VisitorTableRow";

interface Props {
	isLoading: boolean;
	data: IVisitorListItem[];
	paginationSkip: number | string;
	onView: (id: number) => void;
	onEdit: (id: number) => void;
	onDelete: (id: number, name: string) => void;
}

const VisitorTable: React.FC<Props> = ({
	isLoading,
	data,
	paginationSkip,
	onView,
	onEdit,
	onDelete,
}) => {
	return (
		<TableContainer>
			<Table>
				<TableHead>
					<TableRow>
						<TableCell sx={{ fontWeight: "bold" }}>SL.</TableCell>
						<TableCell sx={{ fontWeight: "bold" }}>Visitor No</TableCell>
						<TableCell sx={{ fontWeight: "bold" }}>Visitor Name</TableCell>
						<TableCell sx={{ fontWeight: "bold" }}>Contact Info</TableCell>
						<TableCell sx={{ fontWeight: "bold" }}>Status</TableCell>
						<TableCell sx={{ fontWeight: "bold" }}>Registered At</TableCell>
						<TableCell sx={{ fontWeight: "bold" }} align="right">
							Action
						</TableCell>
					</TableRow>
				</TableHead>

				{isLoading ? (
					<TableLoader />
				) : data && data.length > 0 ? (
					<TableBody>
						{data.map((visitor, index) => (
							<VisitorTableRow
								key={visitor.visitor_id}
								visitor={visitor}
								index={index}
								paginationSkip={paginationSkip}
								onView={onView}
								onEdit={onEdit}
								onDelete={onDelete}
							/>
						))}
					</TableBody>
				) : (
					<TableNotFound />
				)}
			</Table>
		</TableContainer>
	);
};

export default VisitorTable;
